import { render } from "./SignUpSuccessMessage.vue?vue&type=template&id=050c92c0&scoped=true"
import script from "./SignUpSuccessMessage.vue?vue&type=script&lang=js"
export * from "./SignUpSuccessMessage.vue?vue&type=script&lang=js"

import "./SignUpSuccessMessage.vue?vue&type=style&index=0&id=050c92c0&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-050c92c0"]])

export default __exports__